import { Component, OnInit, Input } from '@angular/core';

import { Comunicado } from '../../../base/vo/comunicado';

@Component({
    selector: 'app-ultimos-comunicados-simples',
    templateUrl: './ultimos-comunicados-simples.component.html',
    styleUrls: ['./ultimos-comunicados-simples.component.css']
})
export class UltimosComunicadosSimplesComponent implements OnInit {

    @Input() indice: number;
    @Input() comunicado: Comunicado;

    private imagem: string;
    
    constructor() { }

    ngOnInit() {
        if(this.comunicado.imagem){
            this.imagem = "data:image/png;base64," + this.comunicado.imagem;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/components/dashboard/ultimos-comunicados/ultimos-comunicados-simples/ultimos-comunicados-simples.component.ts